<mat-form-field
  appearance="outline"
  floatLabel="always"
  id="input-component-root"
  [ngClass]="{
    disabled: disabled,
    readonly: readonly && !datepicker,
    'search-field': isSearch(),
    'has-icon-prefix': hasPrefixIcon
  }"
  [ngStyle]="{ 'font-size': fontSize }"
>
  <mat-label>{{ label }}</mat-label>
  <mat-icon matPrefix *ngIf="prefixIcon">{{ prefixIcon }}</mat-icon>
  <span matPrefix *ngIf="prefix">{{ prefix }}</span>
  <input
    *ngIf="!datepicker && !textarea"
    [type]="calculatedType"
    matInput
    [formControl]="control"
    [required]="required"
    [readonly]="readonly"
    [maxLength]="maxLength"
    [mask]="mask"
    [thousandSeparator]="separator!"
    [placeholder]="placeholder!"
    (keydown)="onNumberKeydown($event)"
    (keyup.enter)="control.valid ? searchClickAction() : null"
  />
  <input
    *ngIf="datepicker"
    [type]="calculatedType"
    matInput
    [formControl]="control"
    [required]="required"
    [readonly]="readonly"
    [matDatepicker]="datepicker"
    [placeholder]="placeholder!"
    [min]="minDate"
    [max]="maxDate"
    (focus)="datepicker?.open()"
    (click)="datepicker?.open()"
  />
  <span matSuffix *ngIf="suffix">{{ suffix }}</span>
  <textarea
    *ngIf="textarea"
    matInput
    class="text-area-no-resize"
    rows="3"
    [attr.maxlength]="textareaMaxLength ? textareaMaxLength : 255"
    [formControl]="control"
    [readonly]="readonly"
  ></textarea>
  <mat-icon matSuffix (click)="togglePasswordVisibility()" *ngIf="isPassword()">
    {{ getPasswordIcon() }}
  </mat-icon>
  <button
    mat-button
    matSuffix
    *ngIf="isSearch()"
    (click)="searchClickAction()"
    class="search-button"
    [disabled]="control.invalid"
    (keyup.enter)="searchClickAction()"
  >
    <mat-icon>search</mat-icon>
  </button>
  <mat-spinner
    matSuffix
    [diameter]="15"
    class="mat-spinner-loading"
    *ngIf="isLoading()"
  >
  </mat-spinner>
  <mat-error *ngIf="errorHint">{{ customErrorMessage ? customErrorMessage : errorMessage }}</mat-error>
  <mat-hint *ngIf="hasHint()">{{ hint }}</mat-hint>
</mat-form-field>
